import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { Button, message, Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import { Price } from '@partsbadger/library';
import { PlusOutlined } from '@ant-design/icons';

interface Item {
    additional_requirement: string;
    id: number;
    price: string;
}

interface Props {
    handleAdd: (item: Item) => Promise<void>;
    application_cost: any[];
}

const ApplicationCostItems = (props: Props) => {
    const columns: ColumnProps<Item>[] = [
        {
            title: 'Name',
            dataIndex: 'additional_requirement',
        },

        {
            title: 'Price',
            dataIndex: 'price',
            width: 100,
            render: (t, record) => {
                return (
                    <Fragment>
                        <span>
                            <Price value={record.price} />
                        </span>
                    </Fragment>
                );
            },
        },

        {
            title: 'Action',
            dataIndex: 'actions',
            render: (t, record) => {
                return (
                    <Button
                        style={{
                            color: 'green',
                        }}
                        onClick={() =>
                            props.handleAdd(record).then(() => {
                                message.success('Item Added!');
                            })
                        }
                    >
                        <PlusOutlined />
                        Add To Order
                    </Button>
                );
            },
            align: 'right',
        },
    ];

    return (
        <Fragment>
            <Table<Item>
                rowKey={'id'}
                className={'variation'}
                pagination={false}
                dataSource={props.application_cost}
                columns={columns}
            />
        </Fragment>
    );
};

export default observer(ApplicationCostItems);
